import { render } from "./EtatBoite.vue?vue&type=template&id=4abae9ce&ts=true"
import script from "./EtatBoite.vue?vue&type=script&lang=ts"
export * from "./EtatBoite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__